<template>
  <v-row>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Latest web server error log messages:
        </gg-card-header>
        <gg-card-text>
          <v-textarea :value="parsedToString" :loading="pending" loader-height="5" outlined readonly rows="15"></v-textarea>
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ErrorLogsView',
  components: { },
  data: () => ({
    pending: false,
    logErrors: []
  }),
  created () {
    this.getData()
  },
  computed: {
    ...mapGetters({
      hosting: 'hosting',
      resellerSubAccounts: 'resellerSubAccounts',
    }),
    parsedToString () {
      if (!this.pending && this.logErrors.length === 0) {
        return 'No recent errors exist for your domain'
      }
      const arr = this.logErrors.map(item => item.entry)

      return arr.join('\r\n')
    },
    getPayloadForErrors () {
      const payload = { domain: this.hosting.domain }
      if (this.$route.query.user) {
        let domain = ''
        if (this.resellerSubAccounts.length) {
          domain = this.resellerSubAccounts.find((sub) => {
            return sub.user === this.$route.query.user
          }).domain
        }
        Object.assign(payload, { domain, _username: this.$route.query.user })
      }
      return payload
    },
  },
  methods: {
    ...mapActions({
      loadLogs: 'hosting_stats/loadLogs',
      reportError: 'reportError'
    }),
    async getData () {
      // Prevent empty loading with error on page reload
      if (!this.getPayloadForErrors.domain) {
        return setTimeout(() => {
          this.getData()
        }, 500)
      }
      try {
        this.pending = true
        this.logErrors = await this.loadLogs(this.getPayloadForErrors)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    },
  }
}
</script>

<style scoped>

</style>
